import React from "react";

interface GradientTextProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * GradientText - Text component with gradient color effect
 *
 * Applies a radial gradient (yellow → pink → blue) to text using CSS background-clip.
 * Text appears with a colorful gradient fill effect.
 *
 * @example
 * <GradientText className="text-2xl">Gradient Text</GradientText>
 */
export default function GradientText({ children, className = "" }: GradientTextProps) {
  return (
    <span
      className={`bg-clip-text ${className}`}
      style={{
        backgroundImage:
          "radial-gradient(circle at top right, #FFE76E 0%, #E926FF 50%, #232EFF 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
      }}
    >
      {children}
    </span>
  );
}
